import React from "react";
import Logo from "../Logo";

const index = () => {
  return (
    <div>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light" style={{ position: "relative" }}>
        <ul className="navbar-nav">
          <li className="nav-item">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>

        {/* Logo centrado en móvil — absolute para ignorar items del navbar */}
        <div
          className="d-block d-md-none"
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <Logo style={{ maxHeight: "38px", maxWidth: "140px", width: "auto" }} />
        </div>

        <ul className="navbar-nav ml-auto"></ul>
      </nav>
    </div>
  );
};

export default index;
